/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const LaneDepartureWarning = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 23" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M1.14 21H0v-2.42h1.14V21zm0-3.57H0V15h1.14v2.43zm0-3.57H0v-2.42h1.14v2.42zm0-3.57H0V7.88h1.14v2.41zm0-3.56H0V4.31h1.14v2.42zm0-3.57H0V.74h1.14v2.42zM22 21h-1.19v-2.42H22V21zm0-3.57h-1.19V15H22v2.43zm0-3.57h-1.19v-2.42H22v2.42zm0-3.57h-1.19V7.88H22v2.41zm0-3.56h-1.19V4.31H22v2.42zm0-3.57h-1.19V.74H22v2.42zM18.91 6.22l-1-1V3.81A3.66 3.66 0 0 0 14.2.16h-2a3.66 3.66 0 0 0-3.65 3.65v1.42h-.07l-1 1a.3.3 0 0 0 0 .43l.21.21a.3.3 0 0 0 .43 0l.45-.44v12.39a3.66 3.66 0 0 0 3.65 3.65h2a3.66 3.66 0 0 0 3.65-3.65V6.45l.42.41a.3.3 0 0 0 .43 0l.21-.21a.3.3 0 0 0-.02-.43zM13.3 19.78c-1.71 0-3-1.82-3-1.82v-2.17S11.46 18 13.35 18s3-2.28 3-2.28v2.23S15 19.78 13.3 19.78zm2.57-13.9a4 4 0 0 0-2.48-.48 4 4 0 0 0-2.53.7l-.77-1.66a4 4 0 0 1 3.19-1.37 4 4 0 0 1 3.25 1.21l-.66 1.6z" /></g>
      </g>
    </svg>
  </span>
);

LaneDepartureWarning.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

LaneDepartureWarning.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default LaneDepartureWarning;
